import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AppointeeData} from '../../types/appointment/appointee-data';
import {AddAppointmentService} from '../../services/appointment/add-appointment.service';
import {AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'wsd-add-organization-appointment',
  templateUrl: './add-organization-appointment.component.html',
  styleUrls: ['./add-organization-appointment.component.css']
})
export class AddOrganizationAppointmentComponent implements OnInit {

  @Output()
  onSave = new EventEmitter<AppointeeData>();

  display: boolean;

  appointment: AppointeeData;

  appointmentForm: UntypedFormGroup;

  constructor(private addAppointmentService: AddAppointmentService,
              private fb: UntypedFormBuilder,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.appointmentForm = this.fb.group({
      standardTitle: ['', Validators.required],
      directoryTitle: [],
      directorySecondTitle: [],
      person: ['', this.personRequired.bind(this)],
      mail: ['', this.emailOrEmpty],
      official: [false]
    });
    this.addAppointmentService.messageSent$.subscribe(
      (appointment: AppointeeData) => {
        this.initForm(appointment);
        this.appointmentForm.markAsPristine();
        this.display = true;
      }
    );
  }

  private initForm(data: AppointeeData) {
    this.appointment = data;
    this.appointment.consultant = this.appointment.consultant || {};
    this.appointmentForm.reset();
    this.appointmentForm.get('standardTitle').setValue(this.appointment.standardTitle);
    this.appointmentForm.get('directoryTitle').setValue(this.appointment.directoryTitle);
    this.appointmentForm.get('directorySecondTitle').setValue(this.appointment.directorySecondTitle);
    this.appointmentForm.get('mail').setValue(this.appointment.email);
    this.appointmentForm.get('person').setValue(this.appointment.consultant);
    this.appointmentForm.get('official').setValue(this.appointment.official);
  }

  save() {
    this.appointmentForm.markAsDirty();
    Object.keys(this.appointmentForm.controls).forEach(key => {
      this.appointmentForm.get(key).markAsDirty();
    });
    if (this.appointmentForm.invalid) {
      return;
    }
    this.appointment.standardTitle = this.appointmentForm.get('standardTitle').value;
    this.appointment.directoryTitle = this.appointmentForm.get('directoryTitle').value;
    this.appointment.directorySecondTitle = this.appointmentForm.get('directorySecondTitle').value;
    this.appointment.official = this.appointmentForm.get('official').value;
    if (!this.appointment.id) {
      this.appointment.consultant.id = this.appointmentForm.get('person').value.id;
    }
    this.appointment.email = this.appointmentForm.get('mail').value;
    this.display = false;
    this.onSave.emit(this.appointment);
  }

  // TODO need to create reusable validator
  emailOrEmpty(control: AbstractControl): ValidationErrors | null {
    return control.value ? Validators.email(control) : null;
  }

  personRequired(control: AbstractControl): ValidationErrors | null {
    return (this.appointment && this.appointment.id) ? null : Validators.required(control);
  }

  contactEmailError(): any {
    return {
      'email': this.translate.instant('VALIDATION_ERRORS.EMAIL')
    };
  }

  onSelect(event) {
    this.appointment.consultant.firstName = event.firstName;
    this.appointment.consultant.lastName = event.lastName;
  }

  getFullName(): string {
    let name: string = '';
    if (this.appointment.consultant.firstName) {
      name = this.appointment.consultant.firstName + ' ';
    }
    if (this.appointment.consultant.lastName) {
      name += this.appointment.consultant.lastName;
    }
    return name;
  }

  onSelectTitle(event) {
    if (event.value.official) {
      this.appointmentForm.get('official').setValue(event.official);
    }
  }

}
